import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { EvSpinner } from '@evinced-private/ui-common';

import { getMobileRedirectPath } from 'src/apps/mobile-common/helpers/MobileRedirectHelper';
import { MobileRedirect } from 'src/apps/mobile-common/pages/mobile-redirect/MobileRedirect';
import { MobileSdkRouter } from 'src/apps/mobile-sdk/router/MobileSdkRouter';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

export const MobileSdkRedirect: FC = () => {
	const location = useLocation();
	const { configuration } = useConfiguration();

	if (!configuration) {
		return <EvSpinner />;
	}

	const isNewPlatformEnabled =
		configuration?.PLATFORM?.DEV_TOGGLES?.ENABLE_MOBILE_SDK_NEW_PLATFORM ?? false;
	const redirectPath = getMobileRedirectPath(
		location,
		RoutesHelper.getMobileSdkDashboardPath(),
		RoutesHelper.getMobileSdkV1DashboardPath()
	);

	return (
		<MobileRedirect
			isNewPlatformEnabled={isNewPlatformEnabled}
			redirectTo={redirectPath}
			router={<MobileSdkRouter />}
		/>
	);
};
